<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title style='padding-inline: 0px;'>
            Voorraad in / uit
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <mat-grid-list [cols]="1" [rowHeight]="gridHeight" (window:resize)="onResize()">
        <mat-grid-tile style="overflow: auto; background-color: aliceblue;">
            <mat-grid-tile-header>Project</mat-grid-tile-header>
            <table width='100%'>
                <tr>
                    <td style="text-align: left; padding: 20px;">
                        <b>{{projnr}}</b><br>
                        {{projtxt}}
                    </td>
                    <td style="text-align: right; padding: 20px;">
                        <span style="font-size: 40px;"></span>
                    </td>
                </tr>
            </table>
        </mat-grid-tile>
        <mat-grid-tile style="overflow: auto;">
            <table width='100%'>
                <tr>
                    <td style="text-align: center;" [width]=150>
                        <span *ngIf="validProj">
                            <button mat-fab class="bigfab" color="primary"
                                [style.background-color]="outBound ? 'green' : null"
                                (click)="toggleOutbound()"
                            >
                                <mat-icon *ngIf="!outBound">south</mat-icon>
                                <mat-icon *ngIf="outBound">north</mat-icon>
                            </button>
                            <span *ngIf="!outBound">Inbound / Inslag</span>
                            <span *ngIf="outBound">Outbound / Uitslag</span>
                        </span>
                    </td>
                    <td>
                        <input
                        #scanInp
                        list='ordlisting'
                        placeholder="Scan"
                        class="inputField"
                        onclick="this.select();"
                        onfocus="onFocus();"
                        (keydown)='onKeydown($event)'
                        [(ngModel)]='scanTxt'
                    >
                    </td>
                    <td style="text-align: right; padding: 20px;">
                        <span style="font-size: 40px;">{{artmut}}</span>
                    </td>
                </tr>
            </table>
        </mat-grid-tile>
        <mat-grid-tile style="overflow: auto; background-color: aliceblue;">
            <mat-grid-tile-header>Magazijn</mat-grid-tile-header>
            <table width='100%' *ngIf="validArt">
                <tr>
                    <td style="text-align: left; padding: 20px;">
                        <b>{{artnr}}</b><br>
                        {{arttxt}}<br>
                        <br>
                        Locatie: {{artloc}}
                    </td>
                    <td style="text-align: right; padding: 20px;">
                        <span style="font-size: 40px;">{{artvrd}}</span>
                    </td>
                </tr>
            </table>
        </mat-grid-tile>
    </mat-grid-list>
</ion-content>
